import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { ApplicationConfigService } from 'app/core/config/application-config.service';
import { createRequestOption } from 'app/core/request/request-util';
import { Paginate, SearchWithPagination } from 'app/core/request/request.model';
import { Navigation, NavigationSelect } from './navigation.model';
import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { MsCrudService } from '../../../shared/services/ms-crud/ms-crud.services';
import { MsGridService } from '../../../shared/services/ms-grid/ms-grid.services';
import { MsServiceCoreService } from '../../../shared/services/ms-service-core/ms-service-core.services';
import { SystemService } from '../../../shared/services/ms-system/ms-system.service';

@Injectable({ providedIn: 'root' })
export class NavigationService extends SystemService implements MsCrudService<Navigation> {
	private resourceApiUrl = this.applicationConfigService.getEndpointFor(
		'api/common/navigation',
		'vibraerpws'
	);

	constructor(
		private http: HttpClient,
		private applicationConfigService: ApplicationConfigService,
		private _msGridService: MsGridService,
		private _msServiceCoreService: MsServiceCoreService
	) {
		super('NavigationService', _msGridService, _msServiceCoreService);
	}

	create(data: Navigation): Observable<Navigation> {
		super.create(data);
		return this.http.post<Navigation>(this.resourceApiUrl, data);
	}

	update(data: Navigation): Observable<Navigation> {
		super.update(data);
		return this.http.put<Navigation>(`${this.resourceApiUrl}/${data.id}`, data);
	}

	delete(data: any): Observable<Navigation> {
		return new Observable<Navigation>((subscriber) => {
			this.http.delete<Navigation>(`${this.resourceApiUrl}/${data}`).subscribe({
				next: () => {
					super.delete(data);
					subscriber.next(data);
					subscriber.complete();
				},
				error: (error) => subscriber.error(error),
			});
		});
	}

	find(data: string): Observable<Navigation> {
		super.read(data);
		return this.http.get<Navigation>(
			this.applicationConfigService.getEndpointFor(`${this.resourceApiUrl}/${data}`)
		);
	}

	paginate(req?: SearchWithPagination): Observable<Paginate> {
		const options = createRequestOption(req);
		return this.http.get<Paginate>(`${this.resourceApiUrl}/paginate`, {
			params: options,
		});
	}

	query(req?: SearchWithPagination): Observable<Navigation[]> {
		const options = createRequestOption(req);
		return this.http.get<Navigation[]>(this.resourceApiUrl, {
			params: options,
		});
	}

	getDataGrid(): Subject<DataStateChangeEventArgs> {
		return super.getDataGrid();
	}

	executeGrid(grid: GridComponent, state: DataStateChangeEventArgs): void {
		super.executeGrid(grid, state, this.paginate.bind(this));
	}

	findOfSelect(): Observable<NavigationSelect[]> {
		return this.http.get<NavigationSelect[]>(`${this.resourceApiUrl}/select`);
	}
}
